var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0V0C31.0457 0 40 8.95431 40 20V20C40 31.0457 31.0457 40 20 40V40C8.95431 40 0 31.0457 0 20V20Z",
    fill: "#1882FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.333 24.167C28.333 24.8045 28.0896 25.418 27.6523 25.8818C27.2149 26.3458 26.6161 26.6257 25.9795 26.6631L25.833 26.667H14.166C13.5285 26.6669 12.915 26.4227 12.4512 25.9854C11.9874 25.5479 11.7083 24.9499 11.6709 24.3135L11.666 24.167V16.2793L19.5371 21.5264L19.6338 21.582C19.7477 21.6377 19.8732 21.666 20 21.666C20.1266 21.666 20.2515 21.6375 20.3652 21.582L20.4619 21.5264L28.333 16.2793V24.167ZM25.833 13.333C26.733 13.333 27.5229 13.8083 27.9629 14.5225L20 19.8301L12.0381 14.5225C12.247 14.1831 12.5338 13.8982 12.875 13.6924C13.2161 13.4866 13.6015 13.3654 13.999 13.3389L14.167 13.333H25.833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactEmail);
export default __webpack_public_path__ + "static/media/contact_email.3c078aecce93e6eee787e41479479084.svg";
export { ForwardRef as ReactComponent };